import { Navigation } from 'components'
import Text from 'components/priority/Text/Text'

export const AdminProducts = () => {
  return (
    <>
      <Navigation type="admin" />
      <Text margin="32px 0 0 0">Products</Text>
    </>
  )
}

export default AdminProducts
